import CLIENT from '../utils/restClient';
import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../utils/logger';
import { FileValidationHelper } from '../utils/helpers';

export const MODULE_NAME = 'FILES_CONTROLLER';
const log = new Logger('UPLOAD_PAGE', LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const FILE_UPLOAD = namespaced('FILE_UPLOAD');
const FILE_UPLOAD_OK = namespaced('FILE_UPLOAD_OK');
const FILE_UPLOAD_FAIL = namespaced('FILE_UPLOAD_FAIL');
const FILE_UPLOAD_RESET = namespaced('FILE_UPLOAD_RESET');

export const ACTION_TYPES = {
  FILE_UPLOAD,
  FILE_UPLOAD_OK,
  FILE_UPLOAD_FAIL,
  FILE_UPLOAD_RESET
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: null, loading: false, error: null, upload: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case FILE_UPLOAD:
        return  Object.assign({}, state, {loading: true, upload: action.status, error: null});
      case FILE_UPLOAD_OK:
        return Object.assign({}, state, {loading: false, upload: action.status, error: null});
      case FILE_UPLOAD_FAIL:
        return Object.assign({}, state, {loading: false, upload: action.status});
      case FILE_UPLOAD_RESET:
        return Object.assign({}, state, {loading: false, data: null, upload: null, error: null});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doUploadFile: (file) => {
    return (dispatch, getState) => {
      log.debug('doUploadFile: ', file, getState());
      dispatch({type: FILE_UPLOAD, status: {name: file.name, uploaded: false, loading: true}});
      return CLIENT.uploadFile(file)
        .then((response) => {
          log.debug('uploadFile: success: ', response);
          log.clearAllDictionaryErrors();
          dispatch({type: FILE_UPLOAD_OK, status: {name: file.name, uploaded: true, loading: false, response: response}});
        })
        .catch((error) => {
          log.debug('uploadFile: fail: ', error);
          switch (error.status)
          {
              case 409 :
                  log.setDictionaryMessage(ALL_MESSAGES.DUPLICATE_FILE,error.message);
                  break;
              case 413 :
                  log.setDictionaryMessage(ALL_MESSAGES.LARGE_FILE); 
                  break;
              case 406 :
                  log.setDictionaryMessage(ALL_MESSAGES.VIRUS_SCAN_FAILED);
                  break;
              case 400 :
                  let validationMessage = FileValidationHelper.getFileValidationMessage(error.message);
                  if (validationMessage) {
                    log.setDictionaryMessage(validationMessage);
                  } else {
                    log.setDictionaryMessage(ALL_MESSAGES.UNABLE_TO_PROCESS_FILE, error.message);
                  }
                  break;
          }
          dispatch({type: FILE_UPLOAD_FAIL, status: {name: file.name, uploaded: false, loading: false, error: error}});
        })
    }
  },
  doResetUpload: () => {
    return (dispatch, getState) => {
      dispatch({type: FILE_UPLOAD_RESET});
    }
  }
};

export default API;

